var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-link',{staticClass:"c-btn c-btn--primary c-btn--primary--large c-btn--h-large link-to-login--ledian",attrs:{"to":_vm.loginLink}},[_vm._v("\n  会員登録済みのお客様はこちら\n")])}
var staticRenderFns = []

export { render, staticRenderFns }